<template>
  <div id="body">
    <div id='xtg_left'>
      <router-link :to="{
        path: '/detail/135'
      }">
        <img src="http://yd.top917.cn/date/images/xtg_left.png">
      </router-link>
    </div>
    <img src="http://yd.top917.cn/date/images/xtg_01.jpg">
    <img src="http://yd.top917.cn/date/images/xtg_02.jpg">
    <img src="http://yd.top917.cn/date/images/xtg_03.jpg">
    <img src="http://yd.top917.cn/date/images/xtg_04.jpg">
    <img src="http://yd.top917.cn/date/images/xtg_05.jpg">
    <div>
      <router-link :to="{
        path: '/activity/banking'
      }">
        <div class="paiming"></div>
      </router-link>
      <img src="http://yd.top917.cn/date/images/xtg_06.jpg">
    </div>
  </div>
  
</template>
<style scoped>
  .paiming{
    position: absolute;
    width: 3.8rem;
    height: 0rem;
    bottom: 0.8rem;
    left: 2rem;
    
  }
  #xtg_left{
    position: fixed;
    top: 4rem;
    width: 2rem;
    right: 0rem;
    text-align: center;
    font-weight: bold;
  }
  img{
    width: 100%;
    display: block;
  }
</style>

<script>
import { getMyimg } from "@api/user";
export default {
  name: "Poster",
  components: {},
  props: {},
  data: function() {
    return {
     myimg:{},
    };
  },
  mounted: function() {
	  this.Myimg();
  },
  methods: {
    Myimg:function(){
    	let that = this;
    	getMyimg().then(res=>{
    		that.myimg = res.data;
    	})
    }
  }
};
</script>
